import Dexie, { type Table } from "dexie";
import type { SymbolId } from "./types";

export type LocalRound = {
  id: string;
  createdAt: string;
  updatedAt: string;
  roomId: string;
  round: number;
  frontier: number;
  score: number;
  chain: SymbolId[];
  partnerChain: SymbolId[];
  tags?: string[];
  meta?: Record<string, unknown>;
};

export class MindfoldDB extends Dexie {
  rounds!: Table<LocalRound, string>;
  settings!: Table<{ id: string; createdAt: string; updatedAt: string; value: unknown; tags?: string[]; meta?: Record<string, unknown> }, string>;

  constructor() {
    super("mindfold-lab.v1");
    this.version(1).stores({
      rounds: "id, createdAt, roomId, frontier, score",
      settings: "id, updatedAt"
    });
  }
}

export const db = new MindfoldDB();
